/**
 * Deep N: a little of everything, gently. A creeper vein, a dripping tank, a butterfly under a
 * slime tap, a jade vault, an amoeba pit with a creeper rim and a magic wall under a shelf of
 * boulders (docs/spec/03 §3).
 */

import type { CaveDef } from '../types';

export const deepN: CaveDef = {
  id: 'N',
  name: 'TANGLE',
  hint: 'Every trick you have learned, in one cave. Take your time.',
  intermission: false,
  colors: [4, 13, 7],
  diamondValue: 27,
  extraValue: 50,
  amoebaTime: 40,
  magicWallTime: 15,
  fill: { base: '.', items: [['r', 10], ['d', 4]] },
  levels: [
    { seed: 6401, diamonds: 20, time: 160 },
    { seed: 6402, diamonds: 24, time: 150 },
    { seed: 6403, diamonds: 28, time: 140 },
    { seed: 6404, diamonds: 32, time: 130 },
    { seed: 6405, diamonds: 36, time: 120 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W.....?????????????????????wwwwwwww????W',
    'W.P..t?????????????????????wddrdrdw????W',
    'W..........?????.2.????????wrddrddw????W',
    'W..wx.....w????????????????wssssssw????W',
    'W..w......w????????????????.      .????W',
    'W..w......w????????????????w      .????W',
    'W..w......w???.????????????wwwwwwww????W',
    'W..w......w??w.wwwwwwwwwww?????????????W',
    'W..w......w??x.d.d..d.d..w?WWWWWWW?????W',
    'W..w..a...d.?wwwwwwwwwww.w?WdddddW?????W',
    'W..wwwwwwwW.????????????.?.5dddddW?????W',
    'W??????????????????????????WdddddW?????W',
    'W???wrw????????????????????WWWWWWW?????W',
    'W??.......?????????????????????????????W',
    'W???wsw?????????wwwwwwwww??????????????W',
    'W???w w?????????wrrrrrrrw??????????????W',
    'W???wbw?????????.........??????????????W',
    'W???www?????????wmmmmmmmw??????????????W',
    'W???????????????w       .?????????.....W',
    'W???????????????w       w?????????...X.W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
